<div class="container">
  <luigi-container
    [viewurl]="url"
    id="dcp-lead-form-button"
    webcomponent='{ "selfRegistered": true }'
    [context]="context"
  ></luigi-container>
</div>
